import list from './list';

type Times = typeof list;

/**
 * @private
 * @deprecated 方法名调整为 `list` 。
 */
const times: Times = list;
export default times;
